import axios from '@/api/axios'

const createTrainer = (trainerInput) => {
  return axios.post('/trainers', trainerInput)
}

const getTrainers = () => {
  return axios.get('/trainers')
}

const getTrainersList = (params) => {
  return axios.get('/trainers/list', {params})
}

const getTrainer = (id) => {
  return axios.get(`/trainers/${id}`)
}

const trainerIsBlocked = ({id, isBlocked}) => {
  return axios.put(`/trainers/${id}/isBlocked`, {isBlocked})
}

const updateTrainer = (id, trainerInput) => {
  return axios.put(`/trainers/${id}`, trainerInput)
}

const resetPasswordTrainer = (passwords) => {
  return axios.post(
    `/trainers/${passwords.trainerId}/reset/password`,
    passwords
  )
}

export default {
  createTrainer,
  getTrainers,
  getTrainersList,
  getTrainer,
  updateTrainer,
  resetPasswordTrainer,
  trainerIsBlocked,
}
